import React, { useState, useEffect } from "react";
import localization from "assets/localization/localization";
import ConstantInput from "../Input/constantInput/constantInput";

const AllValetListFilter = ({ applyFilter }) => {
  const parseLocalStorage = () => {
    try {
      const data = JSON.parse(window.localStorage?.filterDataIncentive || "{}");
      return {
        project_id: data.project_id || "",
        user_id: data.user_id || "",
        user_name: data.user_name || "",
        phone_number: data.phone_number || "",
      };
    } catch {
      return {
        project_id: "",
        user_id: "",
        user_name: "",
        phone_number: "",
      };
    }
  };

  const initialFilterInputs = parseLocalStorage();

  const [filterFieldsData, setFilterFieldsData] = useState({
    project_id: initialFilterInputs.project_id,
    user_id: initialFilterInputs.user_id,
    user_name: initialFilterInputs.user_name,
    phone_number: initialFilterInputs.phone_number
  });

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const parts = dateString.split("-");
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  };

  useEffect(() => {
    const storedData = parseLocalStorage();
    setFilterFieldsData({
      project_id: storedData.project_id ? storedData.project_id : "",
      user_id: storedData.user_id ? storedData.user_id : "",
      user_name: storedData.user_name ? storedData.user_name : "",
      phone_number: storedData.phone_number? storedData.phone_number : "",
    });
  }, []);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter({
          project_id: filterFieldsData.project_id
            ? filterFieldsData.project_id
            : "",
          user_id: filterFieldsData.user_id ? filterFieldsData.user_id : "",
          user_name: filterFieldsData.user_name ? filterFieldsData.user_name : "",
          phone_number: filterFieldsData.phone_number? filterFieldsData.phone_number : "",
        });
      }}
    >
      <ConstantInput
        label={"Project Id"}
        value={window.localStorage?.all_valet_list_filter && window.localStorage?.all_valet_list_filter ? JSON.parse(window.localStorage?.all_valet_list_filter)['project_id'] : ""}
        type="text"
        handleChange={(val) => {
          setFilterFieldsData({ ...filterFieldsData, project_id: val });
        }}
      />
      <ConstantInput
        label={"User Id"}
        value={window.localStorage?.all_valet_list_filter && window.localStorage?.all_valet_list_filter ? JSON.parse(window.localStorage?.all_valet_list_filter)['user_id'] : ""}
        type="text"
        handleChange={(val) => {
          setFilterFieldsData({ ...filterFieldsData, user_id: val });
        }}
      />
      <ConstantInput
        label={"User Name"}
        value={window.localStorage?.all_valet_list_filter && window.localStorage?.all_valet_list_filter ? JSON.parse(window.localStorage?.all_valet_list_filter)['user_name'] : ""}
        type="text"
        handleChange={(val) => {
          setFilterFieldsData({ ...filterFieldsData, user_name: val });
        }}
      />
      <ConstantInput
        label={"Phone Number"}
        value={window.localStorage?.all_valet_list_filter && window.localStorage?.all_valet_list_filter ? JSON.parse(window.localStorage?.all_valet_list_filter)['phone_number'] : ""}
        type="number"
        handleChange={(val) => {
          setFilterFieldsData({ ...filterFieldsData, phone_number: val });
        }}
      />
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            setFilterFieldsData(initialFilterInputs);
            applyFilter({
              project_id: "",
              user_id: "",
            });
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default AllValetListFilter;
